<template>
  <div class="nullPage">
    <img src="../../../assets/nullPage.png" alt="" :class="[{ smallImg: isSmall }]" />
    <slot name="tipsText" class="nullPageText"></slot>
    <!-- <div class="nullPageText">{{tipsText}}</div> -->
  </div>
</template>
<script>
export default {
  name: 'nullPage',
  props: {
    isSmall: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  tipsText: {
    ossPath: {
      type: String,
      default: null
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="less" scoped>
.nullPage {
  text-align: center;
  .nullPageText {
    font-size: 0.16rem;
  }
}
.smallImg {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/practise/components/nullPage.vue